// extracted by mini-css-extract-plugin
export default {"root":"IconGroupPeople_root__dD6rt"};